import React from 'react';
import { cn } from '@/utils/style';
interface IProps {
  className?: string;
  children: React.ReactNode;
}

const Contain: React.FC<IProps> = ({ className, children }) => {
  return (
    <div className={cn('container mx-auto w-full', className)}>{children}</div>
  );
};

export default Contain;
